<template>
  <ReflectionCard>
    <template #header>
      <span class="flex justify-between items-center">
        <span>What do you expect to learn from this session?</span>
        <div class="flex items-center">
          <action-message
            :on="this.is_saved"
            message="Your changes have been saved."
          ></action-message>
          <button
            type="button"
            @click="saveReflection"
            class="
              relative
              px-4
              py-1.5
              border border-gray-300
              rounded-md
              text-xs
              font-medium
              text-gray-700
              bg-white
              hover:bg-gray-50
              focus:outline-none
            "
          >
            <span
              v-if="loading"
              class="
                absolute
                left-0
                top-0
                bg-opacity-80 bg-gray-50
                items-center
                justify-center
                flex
                w-full
                h-full
              "
            >
              <div
                class="w-5 h-5 border-vice-teal-500 border-2 rounded-full border-t-0 animate-spin"
              ></div>
            </span>
            Save & continue
          </button>
        </div>
      </span>
    </template>
    <template #content>
      <!-- eslint-disable-next-line max-len -->
      <textarea
        rows="4"
        v-model="this.my_goals_field"
        class="w-full border border-gray-200 rounded"
        :placeholder="`Example: During history taking what questions are used to distinguish between inflammatory and mechanical pain.`"
      ></textarea>
    </template>
  </ReflectionCard>
</template>

<script>
import ReflectionCard from './Components/ReflectionCard.vue';
import ActionMessage from '@/Jetstream/ActionMessage.vue';

export default {
  name: 'WhatExpectCard',
  components: { ReflectionCard, ActionMessage },
  props: {
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      my_goals_field: this.$page.props.session.reflection?.my_goals,
      is_saved: '',
    };
  },
  methods: {
    saveReflection() {
      this.is_saved = true;
      const data = {
        column: 'my_goals',
        value: this.my_goals_field,
        session_id: this.$page.props.session.id,
      };
      this.$emit('reflectionChanged', data);
      setTimeout(() => {
        this.is_saved = false;
      }, 2000);
    },
  },
};
</script>

<style scoped></style>
